<template>
  <div id="rare-list-page">
    <div class="rfp-comon-space-declaration"></div>
    <div class="rfp-rr-most-ratings-list-050-or header">
      <p
        v-if="!noDataFound && ratingsListOption != CAROUSEL_VIEW"
        class="rfp-rr-most-ratings-list-051-or rfp-header-menu"
      >
        <span class="rfp-rr-most-ratings-list-0520-or">{{ resultsCountText }}</span>
      </p>
      <p v-else class="rfp-rr-most-ratings-list-051-or rfp-header-menu">
        <span class="rfp-rr-most-ratings-list-0520-or">
          {{ paginationShowing }}
          {{ totalNoOfApprovedReviews > 0 ? currentPaginationPage + 1 : 0 }} {{ paginationOutof }}
          {{ totalNoOfApprovedReviews }}
        </span>
      </p>
      <div class="header-right">
        <span
          v-if="ratingsListOption != CAROUSEL_VIEW"
          class="rfp-rr-most-ratings-list-061-or"
          @click="filterSortEnableFunction()"
        >
          <div class="rfp-rr-most-ratings-list-062-or">
            <p class="rfp-rr-most-ratings-list-063-or rfp-desktop-view">
              {{ sortDisplayData }}<i class="arrow-down"></i>
            </p>
            <p class="rfp-rr-most-ratings-list-064-or rfp-mobile-view">
              {{ sortDisplayDatamobileView }}<i class="arrow-down"></i>
            </p>
          </div>
        </span>
        <template v-if="supportContent != ''">
          <span class="rfp-common-space"></span>
          <span
            class="rfp-rr-most-ratings-list-055-or rfp-button-radius"
            @click="supportContentEnableFunction()"
            >?</span
          >
        </template>
        <span class="rfp-common-space"></span>
        <span
          v-if="ratingsListOption != CAROUSEL_VIEW"
          class="rfp-rr-most-ratings-list-068-or rr-sort float-left"
        >
          <div class="rfp-rr-most-ratings-list-069-or" @click="hamburger()">
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
            <div class="rfp-rr-most-ratings-list-070-or hamburger__menu"></div>
          </div>
        </span>
      </div>
      <ul
        v-if="filterSortEnable"
        class="rfp-rr-most-ratings-list-066-or rr-sort-content rating-sort rfp-sort-arrow_box"
        :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
      >
        <li
          v-for="(x, listIndex) in sortList"
          :key="listIndex"
          class="rfp-rr-most-ratings-list-067-or black bold"
          @click="sortReviews(x.Key, x.Value)"
        >
          {{ x.Value }}
        </li>
      </ul>
      <ul
        v-if="supportContentEnable"
        class="rfp-rr-most-ratings-list-058-or rr-sort-content rating-sort-sm rfp-support-arrow_box"
      >
        <li class="rfp-rr-most-ratings-list-059-or black">
          <i class="rfp-rr-most-ratings-list-060-or caret up-arrow"></i
          ><span v-html="supportContent"></span>
        </li>
      </ul>
    </div>
    <div v-if="filterDiv">
      <div class="rfp-comon-space-declaration"></div>
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <symbol id="rfp-ratings-checkmark" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-miterlimit="10"
            fill="none"
            d="M22.9 3.7l-15.2 16.6-6.6-7.1"
          ></path>
        </symbol>
      </svg>
      <div class="form-container">
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('one')"
        >
          <input
            v-model="rfpFilterOne"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ oneStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('two')"
        >
          <input
            v-model="rfpFilterTwo"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ twoStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('three')"
        >
          <input
            v-model="rfpFilterThree"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ threeStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('four')"
        >
          <input
            v-model="rfpFilterFour"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ fourStarText }}
          </label>
        </div>
        <div
          class="rfp-ratings-promoted-checkbox"
          :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
          @click="filterByStars('five')"
        >
          <input
            v-model="rfpFilterFive"
            type="checkbox"
            class="rfp-ratings-promoted-input-checkbox"
          />
          <label>
            <svg :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }">
              <use xlink:href="#rfp-ratings-checkmark" />
            </svg>
            {{ fiveStarText }}
          </label>
        </div>
        <span
          v-if="
            (filterCounts >= 2 && stars.oneStar) ||
            (filterCounts >= 2 && stars.twoStar) ||
            (filterCounts >= 2 && stars.threeStar) ||
            (filterCounts >= 2 && stars.fourStar) ||
            (filterCounts >= 2 && stars.fiveStar) ||
            (filterCounts >= 2 && sort.hlr) ||
            (filterCounts >= 2 && sort.lhr) ||
            (filterCounts >= 2 && sort.mh) ||
            (filterCounts >= 2 && sort.mr)
          "
          class="rfp-ratings-clearAll_filter"
          @click="clearAllStars"
          >{{ clearAll }}</span
        >
      </div>
    </div>
    <div class="rfp-comon-space-declaration"></div>
    <div class="rfp-rr-most-ratings-list-095-or rr-all-review-container">
      <div
        v-if="itemsWithNickname.length == 0"
        class="rfp-rr-most-ratings-list-129-or no_record__found"
        v-text="noRecordFound"
      ></div>
      <template v-else-if="ratingsListOption === CAROUSEL_VIEW">
        <rfp-ratings-carousel
          ref="carousel"
          :autoplay="false"
          :autoplay-timeout="10000"
          :loop="false"
          :autoplay-hover-pause="true"
          :min-swipe-distance="8"
          pagination-active-color="#f30606"
          pagination-color="#efefef"
          :pagination-padding="10"
          :pagination-size="10"
          :per-page="1"
          :review-count="totalNoOfApprovedReviews"
          :navigation-enabled="true"
          :pagination-enabled="false"
        >
          <rfp-ratings-slide v-for="item in itemsWithNickname" :key="item.RRID">
            <rfp-ratings-list-item
              :review="item"
              @modal-open="openModal"
              @rating-summary="ratingSummary"
              @update-review="updateReview"
            ></rfp-ratings-list-item>
          </rfp-ratings-slide>
        </rfp-ratings-carousel>
      </template>
      <template v-else-if="ratingsListOption === LOAD_MORE">
        <rfp-ratings-list-item
          v-for="item in itemsWithNickname"
          :key="item.RRID"
          :review="item"
          @modal-open="openModal"
          @rating-summary="ratingSummary"
          @update-review="updateReview"
        ></rfp-ratings-list-item>
        <button
          v-if="numberOfReviews < totalNoOfApprovedReviews"
          class="rfp-ratings-load-more"
          @click="loadMoreHeaddercount"
        >
          <span v-text="showMoreText"></span>
        </button>
      </template>
      <template v-else>
        <refapp-paginate
          ref="paginator"
          name="items"
          :list="items"
          :per="reviewPaginationCount"
          class="rfp-rr-most-ratings-list-096-or paginate-list"
        >
          <rfp-ratings-list-item
            v-for="item in paginated('items')"
            :key="item.RRID"
            :review="item"
            @modal-open="openModal"
            @rating-summary="ratingSummary"
            @update-review="updateReview"
          ></rfp-ratings-list-item>
        </refapp-paginate>
        <div class="rfp-rr-most-ratings-list-130-or rr-table-footer">
          <span class="rfp-rr-most-ratings-list-0520-or" v-text="resultsCountText"></span>
          <div class="rfp-rr-most-ratings-list-132-or rr-table-footer-right float-right">
            <div id="navcontainer">
              <rfp-ratings-pagination-links
                ref="paginationLinks"
                :page-count="totalNoOfApprovedReviewsPagiantions"
                :click-handler="defaultPaginationCalculation"
                :prev-text="paginationPrevious"
                :next-text="paginationNext"
                :container-class="'paginate-links items paginate-ul'"
                active-class="number active paginate-li"
              >
              </rfp-ratings-pagination-links>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="enableModal">
      <rfp-ratings-list-carousel-modal
        :images="carouselConfig.modalImages"
        :main-position="carouselConfig.mainPosition"
        :visible="carouselConfig.showModal"
        :show-actions="carouselConfig.showActions"
        :show-thumbnails="carouselConfig.showThumbnails"
        @closedmodal="closeModal"
      >
      </rfp-ratings-list-carousel-modal>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import axios from 'axios';
import datalayerMixin from '../../../../lib/datalayer-mixin';
import RfpRatingsListCarouselModal from './rfp-ratings-list-carousel-modal/rfp-ratings-list-carousel-modal.vue';
import RfpRatingsCarousel from '../../rfp-ratings-slider/rfp-ratings-carousel.vue';
import RfpRatingsSlide from '../../rfp-ratings-slider/rfp-ratings-slide.vue';
import RfpRatingsPaginationLinks from '../../rfp-ratings-pagination-links/rfp-ratings-pagination-links.vue';
import RfpRatingsListItem from './rfp-ratings-list-item/rfp-ratings-list-item.vue';

const LOAD_MORE = 'Ratings load more';
const CAROUSEL_VIEW = 'carousel list view';

export default {
  name: 'rfp-ratings-list',
  components: {
    RfpRatingsSlide,
    RfpRatingsCarousel,
    RfpRatingsListCarouselModal,
    RfpRatingsListItem,
    RfpRatingsPaginationLinks,
  },
  mixins: [datalayerMixin('rfp-ratings-list')],
  provide() {
    // use function syntax so that we can access `this`
    return {
      ageLabel: this.$props.ageLabel,
      currentPageUrl: window.location.href,
      facebookCaption: this.$props.facebookCaption,
      facebookIcon: this.$props.facebookIcon,
      facebookIconAlt: this.$props.facebookIconAlt,
      facebookShareEnabled: this.$props.facebookShareEnabled,
      fields: this.$props.fields,
      helpfullIcon: this.$props.helpfullIcon,
      helpfullIconAltText: this.$props.helpfullIconAltText,
      helpfulLabel: this.$props.helpfulLabel,
      isRightToLeftActive: this.$props.isRightToLeftActive,
      isProductFreeDisplayText: this.$props.isProductFreeDisplayText,
      nonHelpfullIcon: this.$props.nonHelpfullIcon,
      nonHelpfullIconAltText: this.$props.nonHelpfullIconAltText,
      notRecommendListIcon: this.$props.notRecommendListIcon,
      notRecommendIconAltText: this.$props.notRecommendIconAltText,
      qualityOfProductLabel: this.$props.qualityOfProductLabel,
      shareDisplayConfig: this.$props.shareDisplayConfig,
      showCreatedAt: this.$props.showCreatedAt,
      showCriticalReviewSection: this.$props.showCriticalReviewSection,
      showFavorableReviewSection: this.$props.showFavorableReviewSection,
      showFreeProduct: this.$props.showFreeProduct,
      showHideAgeRange: this.$props.showHideAgeRange,
      showHideLocation: this.$props.showHideLocation,
      showHideQualityRating: this.$props.showHideQualityRating,
      showHideReviewContent: this.$props.showHideReviewContent,
      showHideReviewTitle: this.$props.showHideReviewTitle,
      showHideUserType: this.$props.userTypeShowHide,
      showHideIsProductRecommended: this.$props.showHideIsProductRecommended,
      showLabelNickname: this.$props.showLabelNickname,
      starRatingIncrementValue: this.$props.starRatingIncrementValue,
      starRatingMaxRatingValue: this.$props.starRatingMaxRatingValue,
      starRatingInactiveColor: this.$props.starRatingInactiveColor,
      starRatingActiveColor: this.$props.starRatingActiveColor,
      starRatingStarSize: this.$props.starRatingStarSize,
      recommendListIcon: this.$props.recommendListIcon,
      recommendIconAltText: this.$props.recommendIconAltText,
      reportText: this.$props.reportText,
      reportedText: this.$props.reportedText,
      userTypeDesc: this.$props.userTypeDesc,
    };
  },
  props: {
    enableModal: {
      type: Boolean,
      required: false,
      default: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    supportContent: {
      type: String,
      default: '',
    },
    sortDisplayDatas: {
      type: String,
      required: true,
    },
    sortList: {
      type: Array,
      required: true,
    },
    oneStarText: {
      type: String,
      required: true,
    },
    twoStarText: {
      type: String,
      required: true,
    },
    threeStarText: {
      type: String,
      required: true,
    },
    fourStarText: {
      type: String,
      required: true,
    },
    fiveStarText: {
      type: String,
      required: true,
    },
    activeFilters: {
      type: String,
      required: true,
    },
    clearAll: {
      type: String,
      required: true,
    },
    qualityOfProductLabel: {
      type: String,
      required: true,
    },
    ageLabel: {
      type: String,
      required: true,
    },
    helpfulLabel: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      required: true,
    },
    reported: {
      type: String,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    baseUrlsFetchReviewDetails: {
      type: String,
      required: true,
    },
    reviewPaginationCount: {
      type: Number,
      required: true,
    },
    reviewPaginataionText: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReview: {
      type: String,
      required: true,
    },
    noRecordFound: {
      type: String,
      required: true,
    },
    helpfullIcon: {
      type: String,
      required: true,
    },
    nonHelpfullIcon: {
      type: String,
      required: true,
    },
    helpfullIconAltText: {
      type: String,
      required: true,
    },
    nonHelpfullIconAltText: {
      type: String,
      required: true,
    },
    recommendIconAltText: {
      type: String,
      required: true,
    },
    recommendListIcon: {
      type: String,
      required: true,
    },
    notRecommendIconAltText: {
      type: String,
      required: true,
    },
    notRecommendListIcon: {
      type: String,
      required: true,
    },
    userTypeShowHide: {
      type: Boolean,
      required: true,
    },
    userTypeDesc: {
      type: String,
      required: true,
    },
    paginationShowing: {
      type: String,
      required: true,
    },
    paginationOutof: {
      type: String,
      required: true,
    },
    addIcon: {
      type: String,
      required: true,
    },
    filterEnable: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    reportedText: {
      type: String,
      required: true,
    },
    ratingsListOption: {
      type: String,
      required: false,
    },
    showMoreText: {
      type: String,
      default: 'Show More',
    },
    paginationNext: {
      default: 'Next',
      type: String,
      required: false,
    },
    paginationPrevious: {
      default: 'Previous',
      type: String,
      required: false,
    },
    facebookCaption: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabled: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfig: {
      type: String,
      required: true,
    },
    facebookIcon: {
      type: String,
      default: '',
    },
    facebookIconAlt: {
      type: String,
      default: '',
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showHideLocation: {
      type: Boolean,
      default: true,
    },
    showHideAgeRange: {
      type: Boolean,
      default: true,
    },
    showHideReviewTitle: {
      type: Boolean,
      default: true,
    },
    showCreatedAt: {
      type: Boolean,
      default: true,
    },
    showHideReviewContent: {
      type: Boolean,
      default: true,
    },
    showHideQualityRating: {
      type: Boolean,
      default: true,
    },
    showHideIsProductRecommended: {
      type: Boolean,
      default: true,
    },
    showLabelNickname: {
      type: Boolean,
      default: false,
    },
    showFavorableReviewSection: {
      type: Boolean,
      default: true,
    },
    showCriticalReviewSection: {
      type: Boolean,
      default: true,
    },
    isProductFreeDisplayText: {
      type: String,
      required: false,
    },
    showFreeProduct: {
      type: String,
      required: false,
    },
    sortReviewTags: {
      type: String,
      required: false,
    },
    loadFromMultipleLanguages: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      paginate: ['items'],
      carouselConfig: {
        modalImages: [],
        mainPosition: 0,
        showModal: false,
        showActions: true,
        showThumbnails: true,
      },
      stars: {
        oneStar: false,
        twoStar: false,
        threeStar: false,
        fourStar: false,
        fiveStar: false,
      },
      sort: {
        hlr: false,
        lhr: false,
        mh: false,
        mr: false,
      },
      filterDiv: false,
      upHere: false,
      helpfulLabels: this.helpfulLabel,
      reports: this.report,
      reporteds: this.reported,
      reportDisplayed: false,
      sortDisplayData: this.sortDisplayDatas,
      sortDisplayDatamobileView: this.sortDisplayDatas,
      noDataFound: false,
      toPages: 1,
      supportContentEnable: false,
      filterSortEnable: false,
      reviewsToShow: this.reviewPaginationCount - 1,
      currentPaginationPage: 0,
      rfpFilterOne: false,
      rfpFilterTwo: false,
      rfpFilterThree: false,
      rfpFilterFour: false,
      rfpFilterFive: false,
      currentPageNo: 1,
      totalNoOfApprovedReviews: 0,
      normalPagination: [],
      itemsDefault: [],
      maxPageLength: 1,
      totalNoOfApprovedReviewsPagiantions: 0,
      currentPageUrl: window.location.href,
      filterCounts: 0,
      sortDataCount: 0,
      readReviewTriggered: false,
      CAROUSEL_VIEW,
      LOAD_MORE,
    };
  },
  computed: {
    numberOfReviews() {
      if (this.ratingsListOption === LOAD_MORE) return this.items.length;

      const currentPageTotal = this.currentPageNo * this.reviewPaginationCount;
      const fromCount = currentPageTotal - this.reviewPaginationCount + 1;
      const toCount =
        currentPageTotal > this.totalNoOfApprovedReviews
          ? this.totalNoOfApprovedReviews
          : currentPageTotal;
      return `${fromCount}-${toCount}`;
    },
    resultsCountText() {
      return `${this.paginationShowing} ${this.numberOfReviews} ${this.paginationOutof} ${this.totalNoOfApprovedReviews}`;
    },
    itemsWithNickname() {
      return this.items.filter((review) => review.NickName != '');
    },
  },
  updated() {
    if (
      !this.readReviewTriggered &&
      this.items &&
      this.items.length > 0 &&
      document.querySelector('.rr-user-review-comment') != null
    ) {
      this.onElementVisible(document.querySelector('.rr-user-review-comment'), () => {
        if (!this.readReviewTriggered) {
          eventBus.emit('readReviewTags');
          this.readReviewTriggered = true;
        }
      });
    }
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('FilterstarLabel', () => {
      this.filterCounts = 2;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1; // pagination index
      this.currentPaginationPage = 0; // carousel index
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = true;
      this.stars.fiveStar = true;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = true;
      this.rfpFilterFive = true;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('rfp-global-page-change', (value) => {
      this.currentPaginationPage = value;
    });
    /* istanbul ignore next */
    eventBus.on('oneTwoThree', () => {
      this.filterCounts = 3;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = true;
      this.stars.twoStar = true;
      this.stars.threeStar = true;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = true;
      this.rfpFilterTwo = true;
      this.rfpFilterThree = true;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterOne', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = true;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = true;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterTwo', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = true;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = true;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterThree', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = true;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = true;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterFour', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = true;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = true;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('filterFive', () => {
      this.filterCounts = 1;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = true;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = true;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.fetchReviewDetails();
    });
    /* istanbul ignore next */
    eventBus.on('dataGetFromDB', (val) => {
      const calculation = this.currentPageNo + 1;
      const calculateCondition = val + 2;
      if (calculateCondition > this.items.length) {
        this.currentPageNo = calculation;
        this.fetchReviewDetails(true);
      }
    });

    this.fetchReviewDetails();
  },
  mounted() {
    let listPageEl = document.getElementById('rare-list-page');
    if (listPageEl) {
      this.onElementVisible(listPageEl, () => {
        this.canLoadReviews = true;
        this.fetchReviewDetails();
      });
    }
  },
  methods: {
    openModal(position, data) {
      this.carouselConfig = {
        ...this.carouselConfig,
        mainPosition: position,
        modalImages: data,
        showModal: true,
      };
    },
    closeModal() {
      this.carouselConfig.showModal = false;
    },
    onElementVisible(element, callback) {
      new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
          }
        });
      }).observe(element);
    },
    fetchReviewDetails(concatenateResults = false) {
      if (!this.canLoadReviews) return;

      const params = new URLSearchParams({
        languageCode: this.languageCode,
        productId: this.productId,
        page: this.currentPageNo,
        loadFromMultipleLanguages: this.loadFromMultipleLanguages,
        pageSize: this.reviewPaginationCount,
      });

      Object.values(this.stars).forEach((s, index) => {
        if (s) params.append('filterData', index + 1);
      });

      /**
       * sort is a tuple with the following shape `[key, value]`
       * first member(key) is the sort option name
       * second member(value) is a boolean depicting whether the sort is enabled or not
       *
       * @example ['hlr', true]
       * */
      const sort = Object.entries(this.sort).find((tuple) => tuple[1]);
      if (sort) {
        params.append('sortData', sort.shift());
      }

      return axios
        .get(this.baseUrlsFetchReviewDetails, {
          headers: { Pragma: 'no-cache' },
          params,
        })
        .then((response) => {
          const { ProductReviews, TotalNoOfApprovedReviews } = response.data;
          this.totalNoOfApprovedReviews = TotalNoOfApprovedReviews;

          this.noDataFound = true;

          if (ProductReviews[0]) {
            this.noDataFound = false;
          }

          // in carousel mode, append new pagination items to the list, unless filtering
          // the concatenate flag will only ever be set in the `dataGetFromDB` handler
          if (this.ratingsListOption === CAROUSEL_VIEW || this.ratingsListOption === LOAD_MORE) {
            if (concatenateResults) {
              this.items.push(...ProductReviews);
            } else {
              this.items = ProductReviews;
            }
            return;
          }

          const reviewsPagination = Math.ceil(
            TotalNoOfApprovedReviews / this.reviewPaginationCount,
          );

          this.totalNoOfApprovedReviewsPagiantions = Math.max(reviewsPagination, 1);

          this.items = ProductReviews;
          this.itemsDefault.push({
            ['pages' + this.currentPageNo]: ProductReviews,
          });
        });
    },
    defaultPaginationCalculation(pageNum) {
      this.currentPageNo = pageNum;
      const hardCodeValue = 'pages' + pageNum;
      /* istanbul ignore next */
      const foundValue = this.itemsDefault.filter((obj) => obj[hardCodeValue]);

      if (foundValue.length === 0) {
        this.currentPageNo = pageNum;
        this.maxPageLength = pageNum;
        this.fetchReviewDetails();
      } else {
        /* istanbul ignore next */
        this.items = foundValue[0][hardCodeValue];
      }
      /* istanbul ignore next */
      // this.$scrollTo('#rare-list-page');
    },
    onLangsPageChange(toPage) {
      this.toPages = toPage;
      /* istanbul ignore next */
      // this.$scrollTo('#rare-list-page');
    },
    loadMoreHeaddercount() {
      this.reviewsToShow += this.reviewPaginationCount - 1;
      this.toPages = this.toPages + 1;
      this.currentPageNo = this.toPages;
      this.fetchReviewDetails(true);
    },
    dataLayerTagging(tags) {
      if (!tags) return false;
      eventBus.emit(this.getTaggingEventName(), JSON.parse(tags));
    },
    supportContentEnableFunction() {
      this.filterSortEnable = false;
      if (this.supportContentEnable) {
        /* istanbul ignore next */
        this.supportContentEnable = false;
      } else {
        this.supportContentEnable = true;
      }
    },
    filterSortEnableFunction() {
      this.supportContentEnable = false;
      /* istanbul ignore next */
      if (this.filterSortEnable) {
        this.filterSortEnable = false;
      } else {
        this.filterSortEnable = true;
      }
    },
    sortReviews(direction, displayDatas) {
      this.dataLayerTagging(this.sortReviewTags);
      if (this.sortDataCount === 0) {
        this.sortDataCount = 1;
        this.filterCounts = this.filterCounts + 1;
      }
      /* istanbul ignore next */
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      eventBus.emit('sortReviewsTags', displayDatas);
      this.filterSortEnable = false;
      this.sortDisplayData = displayDatas;
      this.sortDisplayDatamobileView = direction;

      // TODO: Define what hlr, lhr, mh, mr mean
      const base = {
        hlr: false,
        lhr: false,
        mh: false,
        mr: false,
      };

      if (!Object.keys(base).includes(direction))
        throw new Error('error/rfp-ratings-list#sortData');

      this.sort = {
        ...base,
        [direction]: true,
      };

      this.currentPageNo = 1;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.fetchReviewDetails();
    },

    filterByStars(rank) {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }

      const filterIdentifier = `rfpFilter${rank[0].toUpperCase()}${rank.slice(1)}`;
      const starIdentifier = `${rank}Star`;

      if (this.stars[`${rank}Star`]) {
        --this.filterCounts;
      } else {
        ++this.filterCounts;
        eventBus.emit('filter-action-triggered', this[`${rank}StarText`]);
      }

      this.stars[starIdentifier] = !this.stars[starIdentifier];
      this[filterIdentifier] = !this[filterIdentifier];
      this.currentPageNo = 1;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.fetchReviewDetails();
    },

    clearAllStars() {
      const filterKeys = [
        'rfpFilterOne',
        'rfpFilterTwo',
        'rfpFilterThree',
        'rfpFilterFour',
        'rfpFilterFive',
      ];
      Object.keys(this.stars).forEach((key) => (this.stars[key] = false));
      Object.keys(this.sort).forEach((key) => (this.sort[key] = false));
      filterKeys.forEach((key) => (this[key] = false));

      this.sortDataCount = 0;
      this.filterCounts = 0;
      this.sortDisplayData = this.sortDisplayDatas;
      this.sortDisplayDatamobileView = this.sortDisplayDatas;
      this.currentPageNo = 1;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
        this.reviewsToShow = this.reviewPaginationCount - 1;
        this.toPages = 1;
      }
      this.$refs.paginationLinks?.resetPaginationLink();
      this.fetchReviewDetails();
    },
    hamburger() {
      this.filterSortEnable = false;
      this.supportContentEnable = false;
      if (this.filterDiv === true) {
        this.filterDiv = false;
      } else {
        this.filterDiv = true;
      }
    },
    mouseOver() {
      this.active = !this.active;
    },

    ratingSummary(val) {
      axios
        .patch(this.reportReviewApi, { rrID: val }, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          const message = response.data.Message;
          if (message === 'Reported') {
            const reportedItem = this.items.find((item) => item.RRID === val);
            if (reportedItem) {
              reportedItem.IsReported = message;
            }
          }
        });
    },
    _enrichReviewData(isHelpful, reviews, lookupKey, reviewId) {
      reviews?.forEach((r) => {
        if (r[lookupKey] === reviewId)
          return {
            ...r,
            IsHelpfulCookie: 'yes', // TODO: shouldn't this be "NO" when not helpful?
            [isHelpful ? 'HelpfulCount' : 'NotHelpfulCount']: ++r[
              isHelpful ? 'HelpfulCount' : 'NotHelpfulCount'
            ],
          };
      });
    },
    updateReview(reviewId, isHelpful) {
      if (this.$cookies.get(`helpfulCountCookie${reviewId}`) === 'success') return;

      const eventName = isHelpful ? 'LikeReviewTags' : 'unLikeReviewTags';
      const reviewUpdateAPI = this[isHelpful ? 'updateHelpfulReviewApi' : 'updateNotHelpfulReview'];

      eventBus.emit(eventName);
      axios
        .patch(reviewUpdateAPI, { rrID: reviewId }, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (response.data.Message !== 'Success') return;
          this._enrichReviewData(isHelpful, this.items, 'RRID', reviewId);
        })
        .catch((e) => console.error(`error/rfp-ratings-list#updateReview: Operation failed`, e));
    },
  },
};
</script>
